const CountryEntity = (backClient) => ({
  getOptions: async () => await backClient.get("/api/countries/options"),
})

export default CountryEntity
